import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const emitClose = (value: boolean) => {
  emit('update:modelValue', value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "420",
    persistent: "",
    "onUpdate:modelValue": emitClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "logout-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "logout-card__title" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Выход из аккаунта ")
            ])),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "logout-card__text" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Вы уверены, что хотите выйти? Сессия завершится, и понадобится повторный вход. ")
            ])),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "logout-card__actions" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                class: "logout-card__cancel",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emitClose(false))),
                disabled: _ctx.loading
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Отмена ")
                ])),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                class: "logout-card__confirm",
                color: "error",
                variant: "flat",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
                loading: _ctx.loading
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Выйти ")
                ])),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})